
  document.addEventListener("DOMContentLoaded", () => {
    const sliderContainer = document.querySelector(".splide-product-functionalities");
    let splide = null;
    let splideStarted = false;

    if (!sliderContainer) return;

    const resetVideos = () => {
      const videos = document.querySelectorAll(".splide__slide .product-functionality-video video");
      videos.forEach((video) => {
        video.pause();
        video.currentTime = 0;
      });
    };

    const playVideoWithDelay = (slideIndex) => {
      const targetSlide = splide.Components.Slides.getAt(slideIndex);
      if (!targetSlide) return;

      const video = targetSlide.slide.querySelector("video");
      if (video) {
        setTimeout(() => {
          video.play().catch((e) => console.warn("Video play failed", e));
        }, 500); // 500ms delay
      }
    };

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];

      if (entry.isIntersecting) {
        if (!splideStarted) {
          splideStarted = true;

          setTimeout(() => {
            splide = new Splide(".splide-product-functionalities", {
              perPage: 1,
              type: "loop",
              pagination: true,
              arrows: false,
              autoplay: true,
              interval: 5000,
              pauseOnHover: false,
              pauseOnFocus: false,
              start: 0,
              // breakpoints: {
              //   990: {
              //     destroy: true,
              //   },
              // },
            });

            splide.on("mounted", () => {
              resetVideos();
              splide.go(0);
              playVideoWithDelay(0);
            });

            splide.on("move", () => {
              resetVideos();
              playVideoWithDelay(splide.index);
            });

            splide.mount();
          }, 500);
        } else {
          // Re-entering view
          resetVideos();
          splide.go(0);
          playVideoWithDelay(0);
        }
      } else {
        // Out of view
        resetVideos();
        if (splide) {
          splide.go(0);
        }
      }
    }, {
      threshold: 0.1,
    });

    observer.observe(sliderContainer);
  });


document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".product-functionalities-mobile");
  if (!container) return;

  const videos = container.querySelectorAll(".product-functionality-video video");
  let currentIndex = 0;
  let timeoutId = null;
  let isInView = false;

  const resetVideos = () => {
    videos.forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });
  };

  const playSequence = () => {
    // Reset and play current video
    resetVideos();

    const video = videos[currentIndex];
    if (video) {
      video.play().catch((e) => console.warn("Video play failed", e));
    }

    // After 2 seconds, pause current and play next
    timeoutId = setTimeout(() => {
      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      currentIndex = (currentIndex + 1) % videos.length;
      playSequence(); // Recursive call to continue sequence
    }, 2000);
  };

  const startSequence = () => {
    if (timeoutId || videos.length === 0) return;
    playSequence();
  };

  const stopSequence = () => {
    clearTimeout(timeoutId);
    timeoutId = null;
    currentIndex = 0;
    resetVideos();
  };

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      if (entry.isIntersecting && !isInView) {
        isInView = true;
        startSequence();
      } else if (!entry.isIntersecting && isInView) {
        isInView = false;
        stopSequence();
      }
    },
    { threshold: 0.1 }
  );

  observer.observe(container);
});

